import { Component, HostListener, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
	selector: 'app-kamona-custom-dialog',
	templateUrl: './kamona-custom-dialog.component.html',
	styleUrls: ['./kamona-custom-dialog.component.scss'],
})
export class KamonaCustomDialogComponent implements OnInit {
	readonly BASIC_VIEW = 'BASIC_VIEW';
	readonly MOBILE_VIEW = 'MOBILE_VIEW';
	readonly MOBILE_ALERT_VIEW = 'MOBILE_ALERT_VIEW';

	@Input() title: string;
	@Input() message: string;
	@Input() message2: string;
	@Input() message3: string;
	@Input() className: string;
	@Input() dialogType?: 'default' | 'info' | 'confirm' | 'sucess' | 'error' | 'warning' | 'custom' | 'processing' | string;
	@Input() icon: TemplateRef<any>;
	@Input() showIconOnDesktop = true;
	@Input() loading: boolean;
	@Input() kamonaDialogType: 'BASIC_VIEW' | 'MOBILE_VIEW' | 'MOBILE_ALERT_VIEW' = this.MOBILE_VIEW;
	isMobile: boolean;
	breakPoint = 768;

	constructor() {}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	ngOnInit(): void {
		this.setMobile(window.innerWidth);
	}
}
